import { render, staticRenderFns } from "./EditResetPasswordContainer.vue?vue&type=template&id=74969053&"
import script from "./EditResetPasswordContainer.vue?vue&type=script&lang=js&"
export * from "./EditResetPasswordContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports